module.exports = __webpack_public_path__ + "img/pdf.4836d3ea.svg";